import { render, staticRenderFns } from "./BaseInputSelectWithFreightService.vue?vue&type=template&id=85c7c438&scoped=true&"
import script from "./BaseInputSelectWithFreightService.vue?vue&type=script&lang=js&"
export * from "./BaseInputSelectWithFreightService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c7c438",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VIcon})
